const AnomalyResolvedIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" fill="#00BA34" />
      <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="#CCF1D6" />
      <mask id="mask0_8348_14642" maskUnits="userSpaceOnUse" x="3" y="3" width="20" height="20">
        <rect x="3" y="3" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8348_14642)">
        <path
          d="M10.9585 17.6455C10.8474 17.6455 10.7432 17.628 10.646 17.593C10.5488 17.5586 10.4585 17.4997 10.3752 17.4163L6.79185 13.833C6.63907 13.6802 6.56602 13.4822 6.57268 13.2388C6.57991 12.9961 6.65991 12.7983 6.81268 12.6455C6.96546 12.4927 7.15991 12.4163 7.39602 12.4163C7.63213 12.4163 7.82657 12.4927 7.97935 12.6455L10.9585 15.6247L18.021 8.56217C18.1738 8.4094 18.3719 8.33301 18.6152 8.33301C18.858 8.33301 19.0557 8.4094 19.2085 8.56217C19.3613 8.71495 19.4377 8.91273 19.4377 9.15551C19.4377 9.39884 19.3613 9.5969 19.2085 9.74967L11.5418 17.4163C11.4585 17.4997 11.3682 17.5586 11.271 17.593C11.1738 17.628 11.0696 17.6455 10.9585 17.6455Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default AnomalyResolvedIcon;
